module.exports = __webpack_public_path__ + "static/media/mifid.f02adf5a.jpg";